import { app } from '../../app';
import { Controller } from './sp-back.controller';

app.component('spBack', {
    bindings: {defaultBack: '<', reloadSimpleBack: '<'},
    controller: Controller,
    templateUrl: require('./sp-back.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-back/sp-back.component.js